import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductTitleModule } from '@epicuro-next/ataraxia/product-title';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { Product } from 'graphql-api/gql-api-interfaces';

const selector = 'atx-product-card-title';

@DynamicComponentRegister(selector, true)
@Component({
  imports: [ProductTitleModule],
  selector,
  styleUrls: ['./product-card-title.component.scss'],
  templateUrl: './product-card-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardTitleComponent {
  @Input() public product: Product;
  @Input() public titleFields: string[] = ['articleTitle'];
}

DontTreeShake(ProductCardTitleComponent);
